













































































import ALPage from '@/components/core/Page/ALPage.vue';
import Vue from 'vue';
import { DataTableHeader } from 'vuetify';

export default Vue.extend({
  name: 'BomsItemListPage',

  components: { ALPage },

  data() {
    return {
      search: '',
      totalItems: 0,
      bomItems: [],
      dialog: false,
      loading: true,
      options: {
        rowsPerPage: 100
      } as any,
      searchChanged: false,

      headers: [
        {
          text: 'Item',
          align: 'start',
          sortable: false,
          value: 'item',
          width: 120
        },
        { text: 'Component', value: 'item', width: 120, sortable: false },
        {
          text: 'Description',
          value: 'description',
          width: 300,
          sortable: false
        },
        {
          text: 'Item Revision',
          align: 'center',
          value: 'item_revision',
          width: 130,
          sortable: false
        },
        {
          text: 'Material Item',
          value: 'material_item',
          width: 130,
          sortable: false
        },
        {
          text: 'Material Description',
          value: 'material_description',
          width: 300,
          sortable: false
        },
        { text: 'Type', value: 'type', width: 90, sortable: false },
        {
          text: 'Quantity Per',
          align: 'center',
          value: 'quantity',
          width: 120,
          sortable: false
        },
        {
          text: 'U/M',
          value: 'unit',
          align: 'center',
          width: 80,
          sortable: false
        },
        {
          text: 'Per',
          value: 'per',
          width: 70,
          sortable: false
        },
        {
          text: 'Material Unit Cost',
          value: 'material_unit_cost',
          align: 'end',
          width: 150,
          sortable: false
        },
        {
          text: 'Extended Cost',
          value: 'extended_cost',
          align: 'end',
          width: 130,
          sortable: false
        },
        {
          text: 'Revision',
          align: 'center',
          value: 'revision',
          width: 100,
          sortable: false
        }
      ] as DataTableHeader[]
    };
  },

  watch: {
    search(newSearch: string, prevSearch: string) {
      if (newSearch !== prevSearch) {
        this.searchChanged = true;
        this.options.page = 1; //called fetcdata
        this.setData(newSearch);
      }
    },

    options: {
      handler() {},
      deep: true
    }
  },

  methods: {
    updatePage(val: any) {
      if (!this.searchChanged) {
        this.setData(this.search);
      }
    },

    setData(search?: string) {
      return this.fetchDataFromApi(search).then((data: any) => {
        this.bomItems = data.results;
        this.totalItems = data.count;
      });
    },

    fetchDataFromApi(search?: string) {
      // just save this file if you see no async genterator on promises
      //and no const for count
      this.loading = true;
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        // eslint-disable-next-line prefer-const
        let { results, count } = await this.getBoms(search);

        this.searchChanged = false;

        this.loading = false;
        resolve({
          results,
          count
        });
      });
    },

    getBoms(search?: string): any {
      const { page } = this.options;
      const params = new URLSearchParams();
      params.append('page', page);
      if (search!.length) params.append('search', search!);

      return this.$axios({
        method: 'get',
        url: `/v1/csi/boms/`,
        timeout: 15 * (60 * 1000),
        params
      }).then(({ data }: any) => data);
    },

    reopenUpload(err?: any) {
      const upload = (this as any).$refs.uploadfile;
      upload.dialog = true;
    }
  },

  mounted() {
    this.$route.query.search = this.search;
    this.setData(this.search);
  }
});
